import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {BsLinkedin} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_186xirz', 'template_qjush6r', form.current, 'AF6ARNlbgdMiLEpc5')

    e.target.reset();
  };

  return (
    <section id='contact'> 
      <h4>Get In Touch</h4>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>jonasbennettgraff@gmail.com</h5>
            <a href="mailto:jonasbennettgraff@gmail.com">Send a message</a>

          </article>
          <article className="contact__option">
            <BsLinkedin className='contact__option-icon'/>
            <h4>LinkedIn</h4>
            <h5>www.linkedin.com/in/jonasgraff</h5>
            <a href="https://www.linkedin.com/in/jonasgraff" target='_blank'>Connect with me</a>

          </article>
        </div>
        {/*END OF CONTACT OPTIONS**/}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required/>
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact